import { render, staticRenderFns } from "./MyAttendanceCalendar.vue?vue&type=template&id=54ffbc80&scoped=true"
import script from "./MyAttendanceCalendar.vue?vue&type=script&lang=js"
export * from "./MyAttendanceCalendar.vue?vue&type=script&lang=js"
import style0 from "./MyAttendanceCalendar.vue?vue&type=style&index=0&id=54ffbc80&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ffbc80",
  null
  
)

export default component.exports